import { get } from 'svelte/store';
import { location, querystring, replace } from 'svelte-spa-router';
import { user_settings } from 'src/stores/account/user';

/**
 * Legacy `?homeManagement` / `?houseManagement` deep-links land on the new
 * `myHomes` section, which replaced the former combined home-management area.
 */
const HOME_MANAGEMENT_QUERY_ALIASES: Record<string, string> = {
	homeManagement: 'myHomes',
	houseManagement: 'myHomes',
};

export const goToSpecificUserSetting = (
	allItemsRefs: {
		[key: string]: HTMLElement;
		[key: number]: HTMLElement;
	},
	collapsesExpanded?: {
		[key: string]: boolean;
	},
) => {
	const rawSetting = get(querystring).split('&')[0];
	if (!rawSetting) return collapsesExpanded;

	const userSetting = HOME_MANAGEMENT_QUERY_ALIASES[rawSetting] ?? rawSetting;

	if (collapsesExpanded) {
		collapsesExpanded[userSetting] = true;
	}
	replace(get(location));

	const elementRef =
		allItemsRefs[userSetting] ?? document.getElementById(`user-settings-section-${userSetting}`);

	if (elementRef) {
		setTimeout(() => elementRef.scrollIntoView({ behavior: 'smooth' }), 100);
	}
	return collapsesExpanded;
};

/**
 * Check if a specific experimental feature is enabled in user settings
 * 	- This function checks the user settings store for the specified feature
 * 	- It returns true if the feature is enabled, false otherwise
 * @param featureName - The name of the feature to check
 * @returns  true if the feature is enabled, false otherwise
 */
export const isExperimentalEnabled = (featureName: string): boolean => {
	let _user_settings = get(user_settings);
	return _user_settings?.experimental_features?.[featureName]?.enabled === 1;
};

/**
 * Check if the user has access to energy exchange features
 * 	- Checks if the user has the 'energy_exchange' business feature enabled
 * 	- Also checks if the user's email is in the whitelisted beta testers list
 * @param userEmail - The user's email address
 * @param businessFeatures - Array of business features from user settings
 * @returns true if the user has access to energy exchange features, false otherwise
 */
export const hasEnergyExchangeAccess = (userEmail: string, businessFeatures: any[] = []): boolean => {
	return false;
};
